/**
 * Amplitude Feature Flag Experiment 'feature key' constants
 */
export const AmplitudeExperiments = {
    AverageLotValueActionCalendarRanking: 'sear-1266-alv-auction-calendar-ranking',
    ChairishRecommendationsOnZeroResultsPage: 'sear-865-chairish-recommendations-on-la-zrp',
    ElasticOnCategoryPages: 'sear-641-use-of-elastic-on-category-pages',
    ExposureVsPageViewedCheck: 'exposure-vs-page-viewed-check',
    CookiebotUiRedesign: 'laac-1570-cookiebot-ui-redesign',
    ItemPageDiscoverMoreFromThisAuction: 'laac-1126-item-page-discover-more-from-this-auction',
    // new item page layout experiment created 01/12/2026
    LaNewItemPageLayout: 'la-new-item-page-layout-test-2',
    // initial ltr experiment
    LearningToRankSearchReRanking: 'sear-1070-ltr-mvp-v1-search-ranking',
    // LAAC-1674 / LAAC-1711 — Amplitude key: laac-1674-app-download-prompt
    AppDownloadPrompt: 'laac-1674-app-download-prompt',
    // new bidding console experiment
    BiddersWatching: 'laac-1704-change-watcher-count-display-copy',
    NewBiddingConsole: 'laac-1564-live-console-v2',
    NewSimilarItemsCTA: 'sear-769-similar-item-cta-on-srps',
    NoReservePriceBadge: 'la-display-no-reserve-message',
    PopularityScoreReRanking: 'sear-1021-popularity-score-re-ranking-v2',
    PurchaseProtectionMessaging: 'ups-4437',
    ReplaceRecommendedItemsWithSimilarLots: 'sear-1274-recommended-items-using-similar-lots',
    SearchResultsAdExperiment: 'ups-4049',
    SimilarLotsSellerDiversity: 'sear-1100-similar-lots-seller-diversity',
    SimplifiedCategoryPage: 'simplified-category-page',
    VariantJumpingHomePageCheck: 'variant-jumping-home-page-check',
} as const;

export type AmplitudeExperimentIds = (typeof AmplitudeExperiments)[keyof typeof AmplitudeExperiments];

export const AmplitudeVariants: {
    [key in keyof typeof AmplitudeExperiments]: {
        [variant: string]: string;
        Control: 'control';
        Treatment?: 'treatment';
        TreatmentB?: 'treatmentB';
    };
} = {
    AverageLotValueActionCalendarRanking: {
        Control: 'control',
        Treatment: 'treatment',
    },

    ChairishRecommendationsOnZeroResultsPage: {
        Control: 'control',
        Treatment: 'treatment',
    },
    BiddersWatching: {
        Control: 'control',
        Treatment: 'treatment',
    },
    CookiebotUiRedesign: {
        Control: 'control',
        Treatment: 'treatment',
    },
    ElasticOnCategoryPages: {
        Control: 'control',
        Treatment: 'treatment',
    },
    ExposureVsPageViewedCheck: {
        Control: 'control',
        Off: 'off',
        Treatment: 'treatment',
    },
    ItemPageDiscoverMoreFromThisAuction: {
        Control: 'control',
        Treatment: 'treatment',
    },
    LaNewItemPageLayout: {
        Control: 'control',
        Treatment: 'treatment',
    },
    LearningToRankSearchReRanking: {
        Control: 'control',
        LargeTrainingDataModel: 'treatmentb',
        SmallTrainingDataModel: 'treatmenta',
    },
    AppDownloadPrompt: {
        Control: 'control',
        Treatment: 'treatment',
    },
    NewBiddingConsole: {
        Control: 'control',
        Treatment: 'treatment',
    },
    NewSimilarItemsCTA: {
        Control: 'control',
        IconCTA: 'treatmentb',
        TextCTA: 'treatmenta',
    },
    NoReservePriceBadge: {
        Control: 'control',
        Treatment: 'treatment',
    },
    PopularityScoreReRanking: {
        AddPopularityKeepingBidCount: 'treatmenta',
        AddPopularityRemovingBidCount: 'treatmentb',
        Control: 'control',
    },
    PurchaseProtectionMessaging: {
        Control: 'control',
        Treatment: 'treatment',
    },
    ReplaceRecommendedItemsWithSimilarLots: {
        Control: 'control',
        Treatment: 'treatment',
    },
    SearchResultsAdExperiment: {
        Control: 'control',
        NewDesign: 'new-design',
    },
    SimilarLotsSellerDiversity: {
        Control: 'control',
        StrictCapNoBackfill: 'treatmenta',
        SoftCapWithBackfill: 'treatmentb',
    },
    SimplifiedCategoryPage: {
        Control: 'control',
        Treatment: 'treatment',
    },
    VariantJumpingHomePageCheck: {
        Control: 'control',
        Treatment: 'treatment',
    },
} as const;

export type AmplitudeExperimentsVariantIds = (typeof AmplitudeVariants)[keyof typeof AmplitudeVariants];
